import { Link } from 'react-router-dom';
import Logo from '@/components/ui/logo';
import { getCompanyName, getCompanyEmails } from '@/lib/config';
import { useAppConfig } from '@/lib/hooks/useAppConfig';

export function Footer() {
  const { waitingListMode } = useAppConfig();

  return (
    <footer className="bg-card">
      <div className="max-w-7xl mx-auto pt-32 pb-12 px-8 lg:px-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company with Product and Support below */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <Logo />
            </Link>

            <div className="flex gap-16">
              {/* Product */}
              {!waitingListMode && (
                <div>
                  <h3 className="text-sm font-semibold text-content-heading mb-3">Product</h3>
                  <ul className="space-y-2">
                    <li>
                      <Link to="/pricing" className="text-sm text-content-secondary hover:text-content-heading">
                        Pricing
                      </Link>
                    </li>
                    <li>
                      <Link to="/sign-up" className="text-sm text-content-secondary hover:text-content-heading">
                        Get Started
                      </Link>
                    </li>
                    <li>
                      <Link to="/sign-in" className="text-sm text-content-secondary hover:text-content-heading">
                        Log In
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Support */}
              <div>
                <h3 className="text-sm font-semibold text-content-heading mb-3">Support</h3>
                <ul className="space-y-2">
                  <li>
                    <a href={`mailto:${getCompanyEmails().support}`} className="text-sm text-content-secondary hover:text-content-heading">
                      Contact Support
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 flex items-center justify-between">
          <p className="text-sm text-content-secondary">
            © {new Date().getFullYear()} {getCompanyName()}. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-sm text-content-secondary hover:text-content-heading">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-content-secondary hover:text-content-heading">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

